// Configuración de valores asíncronos del ambiente.
// Este archivo NO debe estar ignorado en el repositorio.

import { API } from 'aws-amplify';
import * as SecureLS from 'secure-ls';

const ls = new SecureLS();
const nombreApiConfiguracion = 'apiConfiguracion';
const rutaValoresConfiguracion = '/valoresConfiguracion';
const llaveValoresConfiguracion = 'configuracion';
const objetoMuñeco = {};

import {apiGetEboletaConfigEmision} from '@/library/api/config'

const actualizarValoresConfiguracion = async function() {
	// Solicitar valores desde lambda
	
	let valoresConfiguracion;
	
	try {
		const [configuraciones, emision] = await Promise.all([
			API.get(nombreApiConfiguracion, rutaValoresConfiguracion),
			apiGetEboletaConfigEmision()
		]);

		valoresConfiguracion = {
			...configuraciones,
			...emision
		}
	}
	catch(e) {
		console.log('e', e)
		throw 'Error al intentar actualizar los valores de configuración';
	}
	
	// Guardar datos obtenidos en store
	ls.set(llaveValoresConfiguracion, valoresConfiguracion);
	
	return valoresConfiguracion;
};

const obtenerValoresConfiguracion = async function() {
	// Intentar obtener valores desde lambda. Sino se puede (probablemente caso offline),
	// usar los valores guardados en local storage... si no existen, ahí fallar
	
	let valoresConfiguracion;
	
	try {
		valoresConfiguracion = await actualizarValoresConfiguracion();
	}
	catch(e) {
		// Falló, intentar usar datos guardados
		let storedKeys = ls.getAllKeys();
		let llaveExiste = storedKeys.includes(llaveValoresConfiguracion);
		if(!llaveExiste) {
			// No existe llave... Entonces aún no se han guardado datos por primera vez
			// Retornar valor por defecto undefined
			return undefined;
		}
		let storedValoresConfiguracion = ls.get(llaveValoresConfiguracion);
		valoresConfiguracion = storedValoresConfiguracion;
	}
	
	return valoresConfiguracion;
};

const manejadorProxy = {
	get: async function(objetivo, nombreAtributo) {
		const valores = await obtenerValoresConfiguracion();
		if(valores === undefined) {
			return undefined;
		}
		const valor = valores[nombreAtributo];
		return valor;
	},
	set: function(objetivo, nombreAtributo, valor) {
		throw 'La modificación de valores de configuración no está implementada';
	},
};

// Véase https://developer.mozilla.org/es/docs/Web/JavaScript/Reference/Global_Objects/Proxy
// para detalles. Proxy se comporta como un "objeto virtual" que se pone "en medio" de gets y sets hacia
// un objeto real. Es capaz de saber qué atributo se intenta obtener y hacer algo en función de ello.
export default new Proxy(objetoMuñeco, manejadorProxy);
export const actualizar = actualizarValoresConfiguracion;
